/**
 * Left Nav functions
 */

// On click, Open My Account
var openMyAccount = function() {
    'use strict';

    var $openMyAccount = jQuery('.openMyAccount');

    if($openMyAccount.length !== 0) {

        $openMyAccount.bind('click', function (e) {

            var subAccount = document.getElementsByClassName('ln--sub-cat-container');

            $(this).toggleClass('active');

            if ($(this).attr('aria-expanded') == 'false') {
                $(this).attr('aria-expanded', 'true');
            } else {
                $(this).attr('aria-expanded', 'false');
            }

            $(this).parent().next().slideToggle('fast');

            e.preventDefault();
        });
    }
};

/*global jQuery:false */
jQuery(document).ready(function () {
    'use strict';

    openMyAccount();
});
